import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex gap-2.5 sm:gap-3',
    imageContainer:
      'relative aspect-square max-w-25 cursor-pointer overflow-hidden',
    image: 'size-full object-cover',
    moreImages:
      'sm:heading-2xl heading-xl absolute inset-0 flex items-center justify-center bg-white/2 text-white backdrop-blur-[20px]'
  }
});
